module.exports = __webpack_public_path__ + "static/media/Employer_branding_1_C.6827c85b.png";